import { render } from "./SvgGradients.vue?vue&type=template&id=649a5fe4"
import script from "./SvgGradients.vue?vue&type=script&lang=js"
export * from "./SvgGradients.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.21.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__